<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.contactClsManager") }}</h4>
    </div>
    <div class="list_bottom_bt">
      <button type="button" @click="saveNewMem" class="btn btn-primary btn-md m-2">
        {{ $t("common.save") }}
      </button>
    </div>
    <div>
      <table class="list_tbl">
        <thead>
          <tr>
            <th class="mobile_h">{{ $t("common.classify") }}</th>
            <th class="mobile_h">{{ $t("signup.name") }}</th>
            <th class="mobile_h">{{ $t("signup.email") }}</th>
            <th class="mobile_h">{{ $t("management.telNumber") }}</th>
            <th class="mobile_h">{{ $t("common.description") }}</th>
            <th class="mobile_h"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cls, index) in clsList" :key="index">
            <td v-if="cls.classId == null">
              {{ cls.className }}
              <button
                @click="addMember(cls.orgClass, cls.className)"
                class="product_add_bt"
              >
                {{ $t("common.add") }}
              </button>
            </td>
            <td colspan="5">
              <table class="list_tbl inner_tb">
                <tr v-for="(mem, index) in memList" :key="index">
                  <td
                    v-if="cls.orgClass == mem.classId"
                    class="d-flex"
                    :id="'mem' + index"
                  >
                    <input
                      type="text"
                      v-model="mem.userName"
                      class="form-control"
                      name="userName"
                      v-validate="'required'"
                    />
                    <input
                      type="text"
                      v-model="mem.contactEmail"
                      class="form-control"
                      name="contactEmail"
                      v-validate="'required'"
                    />
                    <input
                      type="text"
                      v-model="mem.contactPhone"
                      class="form-control"
                      name="contactPhone"
                      v-validate="'required'"
                    />
                    <input type="text" v-model="mem.contactDesc" class="form-control" />
                  </td>
                  <td v-if="cls.orgClass == mem.classId">
                    <button
                      type="button"
                      @click="deleteContactMember(mem, index)"
                      class="btn btn-secondary btn-sm"
                    >
                      {{ $t("common.delete") }}
                    </button>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <CommonModal id="memModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("common.add") }}</h3>
      </template>
      <template slot="body">
        <div class="list_top_box">
          <div class="float-end">
            <div class="list_top_search d-flex">
              <select
                class="int_type01"
                v-model="form.searchType"
                aria-label="sort select"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="loginId">{{ $t("management.id") }}</option>
                <option value="userName">{{ $t("common.name") }}</option>
              </select>
              <input
                type="text"
                v-model="form.searchWord"
                name="userName"
                class="m-1 form-control"
              />
              <a
                id="btnSearch"
                @click="searchBtn"
                href="#"
                class="btn btn-primary btn-lg"
                >{{ $t("common.search") }}</a
              >
            </div>
          </div>
        </div>
        <table class="list_tbl inner_tb">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  @click="goCheckAll($event.target.checked)"
                  class="form-check-input"
                  v-model="checkAll"
                />
              </th>
              <th class="mobile_h">{{ $t("management.id") }}</th>
              <th class="mobile_h">{{ $t("signup.name") }}</th>
              <th class="mobile_h">{{ $t("signup.email") }}</th>
              <th class="mobile_h">{{ $t("management.telNumber") }}</th>
            </tr>
          </thead>
          <tbody v-if="mgmtUser.length != 0">
            <tr v-for="(item, index) in mgmtUser" :key="index">
              <td>
                <input type="checkbox" v-model="item.selected" class="form-check-input" />
              </td>
              <td>{{ item.loginId }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ item.emailAddress }}</td>
              <td>{{ item.mobileTelNo }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="mgmtUser.length != 0" class="paging_nav">
          <div class="paging_nav">
            <a
              href="#"
              v-if="pagingVO.startPage <= pagingVO.blockSize"
              class="page_select prev_page disabled"
              >이전페이지 이동</a
            >
            <a
              v-else
              class="page_select prev_page"
              @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
              v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
              >이전페이지 이동</a
            >
            <span
              v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
              :key="index"
            >
              <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
                pagingVO.startPage + index
              }}</strong>
              <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
                pagingVO.startPage + index
              }}</a>
            </span>
            <a
              v-if="pagingVO.endPage >= pagingVO.totalPage"
              href="#"
              class="page_select next_page disabled"
              >다음페이지 이동</a
            >
            <a
              v-else
              href="#"
              @click="searchPage(pagingVO.endPage + 1)"
              v-bind:data-page="pagingVO.endPage + 1"
              class="page_select next_page"
              >다음페이지 이동</a
            >
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getSelected" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import $ from "jquery";
import { getContactMgmtList, saveContactClsMember } from "@/api/contact";
import { getMgmtUser } from "@/api/user";
import CommonModal from "@/components/modal/CommonModal";

export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      active: false,
      // members : '',
      clsList: "",
      memList: "",
      // classList : [],
      confirmYN: false,
      newMem: {
        contactId: "",
        classId: "",
        className: "",
        userName: "",
        contactEmail: "",
        contactPhone: "",
        crudType: "D",
      },
      form: {
        searchType: "",
        searchWord: "",
        page: 1,
      },
      pagingVO: "",
      mgmtUser: "",
      checkAll: false,
      conformYN: false,
      showModal: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getContactMgmtList();
        console.log(data);
        this.memList = data.contactMem;
        this.clsList = data.clsList;
      } catch (err) {
        console.log(err);
      }
    },
    // 관리자 검색 모달 show
    async addMember(orgClass, className) {
      this.showModal = true;
      this.newMem.classId = orgClass;
      this.newMem.className = className;
      try {
        const { data } = await getMgmtUser(this.form);
        this.mgmtUser = data.pagingVO.dataList;
        this.pagingVO = data.pagingVO;
      } catch (err) {
        console.log(err);
      }
    },
    closeModal() {
      this.showModal = false;
      this.form.searchType = "";
      this.form.searchWord = "";
    },
    // 관리자 검색
    searchBtn() {
      this.form.page = 1;
      this.addMember();
    },
    // 페이지 클릭 시
    searchPage(page) {
      this.form.page = page;
      this.addMember();
    },
    // 전체선택
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.mgmtUser) {
        this.mgmtUser[i].selected = this.checkAll;
      }
    },
    // 선택한 관리자 추가
    getSelected() {
      for (let i in this.mgmtUser) {
        if (this.mgmtUser[i].selected) {
          this.mgmtUser[i].crudType = "I";
          this.mgmtUser[i].classId = this.newMem.classId;
          this.mgmtUser[i].className = this.newMem.className;
          this.mgmtUser[i].contactEmail = this.mgmtUser[i].emailAddress;
          this.mgmtUser[i].contactPhone = this.mgmtUser[i].mobileTelNo;
          this.memList.push(this.mgmtUser[i]);
        }
      }
      this.form.searchType = "";
      this.form.searchWord = "";
      this.showModal = false;
    },
    // 담당자 추가/수정/삭제
    async saveNewMem() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      if (!confirm(this.$t("alert.save"))) return;
      // }
      try {
        const { data } = await saveContactClsMember(this.memList);
        if (data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          this.showModal = false;
          this.memList = [];
          this.fetchData();
          alert(this.$t("alert.changedSuccessfully"));
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    deleteContactMember(mem, index) {
      if (!confirm(this.$t("alert.delete"))) return;
      $("#mem" + index)
        .closest("tr")
        .remove();
      this.memList[index].crudType = "D";
      alert(this.$t("alert.deletedSuccessfullyButYouNeedToClickTheSaveButton"));
    },
  },
};
</script>

<style>
.inner_tb tr td {
  border-bottom: 0 !important;
}
</style>
